import React, { Component } from "react";
import srcAddWhite from "../../../../styles/img/add-white.svg";
import {
  switchTypeCompte,
  switchEtatCompte,
  switchFonction,
  formatName,
} from "../../../../ReactConst";
import { connect } from "react-redux";
import {
  getStaffCreche,
  postNewStaff,
  updateCouplageCompte,
  updateStaff,
  deleteAgent,
  updateAgentSections,
} from "./staffPlan.ducks";
import { getSections } from "./sections.ducks";
import _ from "lodash";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import ModalAjoutStaff from "./staff-creche/ModalAjoutStaff";
import ModalModifStaff from "./staff-creche/ModalModifStaff";
import { getAccount } from "../../../../modules/auth/Auth.ducks";
import jwt_decode from "jwt-decode";
import ModalConfiramtionOffCompte from "./ModalConfiramtionOffCompte";
import ModalErreurCompte from "./ModalErreurCompte";
import ModalConfiramtionDeleteCompte from "./ModalConfiramtionDeleteCompte";
import ModalErreurDeleteCompte from "./ModalErreurDeleteCompte";
import ModalConfiramtionDeleteCompteMoreAdmin from "./ModalConfiramtionDeleteCompteMoreAdmin";

import { logout } from "./../../../../modules/auth/Auth.ducks";
import { withTranslation } from 'react-i18next';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const AddWhite = () => (
  <object
    data={srcAddWhite}
    type="image/svg+xml"
    style={{ pointerEvents: "none", width: "12px", height: "12px" }}
    className="img-fluid"
  />
);

class StaffCreche extends Component {
  constructor(props) {
    super(props);
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    this.state = {
      agents: [],
      numTotalAgent: null,
      isOpenAjout: false,
      isOpenModif: false,
      agentActif: false,
      numberAdmin: false,
      modalOffCompte: false,
      modalErreurCompte: false,
      modalDeleteCompte: false,
      modalErreurDeleteCompte: false,
      ModaleDeletCompteMoreAdmin: false,
      idAgent: null,
      agent: null,
      tokenDecoded: tokenDecoded,
    };
    this.openModalAjout = this.openModalAjout.bind(this);
    this.closeModalAjout = this.closeModalAjout.bind(this);
    this.openModalModif = this.openModalModif.bind(this);
    this.closeModalModif = this.closeModalModif.bind(this);
    this.closeModalAjout = this.closeModalAjout.bind(this);
    this.submitAjoutStaff = this.submitAjoutStaff.bind(this);
    this.submitModifStaff = this.submitModifStaff.bind(this);
    this.handleCouplageCompte = this.handleCouplageCompte.bind(this);
    this.openModalOffCompte = this.openModalOffCompte.bind(this);
    this.closeModalOffCompte = this.closeModalOffCompte.bind(this);
    this.openModaErreurCompte = this.openModaErreurCompte.bind(this);
    this.closeModaErreurCompte = this.closeModaErreurCompte.bind(this);
    this.openModalDeleteCompte = this.openModalDeleteCompte.bind(this);
    this.closeModalDeleteCompte = this.closeModalDeleteCompte.bind(this);
    this.openModaErreurDeleteCompte = this.openModaErreurDeleteCompte.bind(
      this
    );
    this.closeModaErreurDeleteCompte = this.closeModaErreurDeleteCompte.bind(
      this
    );

    this.openModaErreurDeleteCompteMoreAdmin = this.openModaErreurDeleteCompteMoreAdmin.bind(
      this
    );
    this.closeModaErreurDeleteCompteMoreAdmin = this.closeModaErreurDeleteCompteMoreAdmin.bind(
      this
    );

    this.handleDeleteCompte = this.handleDeleteCompte.bind(this);
    this.CheckModalOpen = this.CheckModalOpen.bind(this);
    this.CheckModalDeleteOpen = this.CheckModalDeleteOpen.bind(this);
  }
  componentDidMount() {
    this.props.getStaffCreche(localStorage.getItem("token"));
    this.props.getSections(localStorage.getItem("token"));
  }
  componentDidUpdate(prevProps) {
    let dataStaff = this.props.dataStaff;
    if (prevProps.dataStaff !== this.props.dataStaff) {
      if (!_.isEmpty(dataStaff.agents)) {
        this.setState({
          agents: dataStaff.agents,
          numTotalAgent: dataStaff.agents.length,
        });
      }
    }
  }
  openModalAjout() {
    this.setState({ isOpenAjout: true });
  }
  closeModalAjout() {
    this.setState({ isOpenAjout: false });
  }
  openModalModif(agent) {
    this.setState({ isOpenModif: true, agent: agent });
  }
  closeModalModif() {
    this.setState({ isOpenModif: false });
  }
  openModalOffCompte() {
    this.setState({ modalOffCompte: true });
  }
  closeModalOffCompte() {
    this.setState({ modalOffCompte: false });
  }
  openModaErreurCompte() {
    this.setState({ modalErreurCompte: true });
  }
  closeModaErreurCompte() {
    this.setState({ modalErreurCompte: false });
  }
  openModalDeleteCompte() {
    this.setState({ modalDeleteCompte: true });
  }
  closeModalDeleteCompte() {
    this.setState({ modalDeleteCompte: false });
  }
  openModaErreurDeleteCompte() {
    this.setState({ modalErreurDeleteCompte: true });
  }
  closeModaErreurDeleteCompte() {
    this.setState({ modalErreurDeleteCompte: false });
  }
  openModaErreurDeleteCompteMoreAdmin() {
    this.setState({ ModaleDeletCompteMoreAdmin: true });
  }
  closeModaErreurDeleteCompteMoreAdmin() {
    this.setState({ ModaleDeletCompteMoreAdmin: false });
  }
  submitAjoutStaff(data) {
    this.props.postNewStaff(localStorage.getItem("token"), data);
    this.closeModalAjout();
  }
  submitModifStaff(data, id, yesLogout) {
    this.props.updateStaff(localStorage.getItem("token"), data, id, yesLogout);
    this.closeModalModif();
  }
  handleCouplageCompte() {
    let agent = Array.from(this.state.agents).find(
      (element) => element.id === this.state.idAgent
    );
    let data = {
      actif: !agent.agentActif,
    };
    let yesLogout = this.state.tokenDecoded.AGENT_ID === this.state.idAgent;
    this.props.updateCouplageCompte(
      localStorage.getItem("token"),
      this.state.idAgent,
      data,
      yesLogout
    );

    this.setState({ modalOffCompte: false, idAgent: null });
  }
  CheckModalOpen(event, agentId) {
    let agent = Array.from(this.state.agents).find(
      (element) => element.id === agentId
    );
    let i = 0;
    this.state.agents.map(function(element) {
      if (
        element.typeCompte === "ADMIN_CRECHE" &&
        element.agentActif === true
      ) {
        i = i + 1;
      }
    });
    if (agent.agentActif === true) {
      if (
        agent.typeCompte === "ADMIN_CRECHE" &&
        i > 1 &&
        this.state.tokenDecoded.AGENT_ID === agentId
      ) {
        this.setState({ modalOffCompte: true, idAgent: agentId });
      } else if (agent.typeCompte === "ADMIN_CRECHE" && i === 1) {
        this.setState({ modalErreurCompte: true, idAgent: agentId });
      } else {
        let agent = Array.from(this.state.agents).find(
          (element) => element.id === agentId
        );
        let data = {
          actif: !agent.agentActif,
        };
        this.props.updateCouplageCompte(
          localStorage.getItem("token"),
          agentId,
          data
        );
      }
    } else {
      let agent = Array.from(this.state.agents).find(
        (element) => element.id === agentId
      );
      let data = {
        actif: !agent.agentActif,
      };
      this.props.updateCouplageCompte(
        localStorage.getItem("token"),
        agentId,
        data
      );
    }
  }
  //  {----Delete compte----}
  handleDeleteCompte() {
    let agent = Array.from(this.state.agents).find(
      (element) => element.id === this.state.idAgent
    );
    let yesLogout = this.state.tokenDecoded.AGENT_ID === this.state.idAgent;
    this.props.deleteAgent(
      localStorage.getItem("token"),
      this.state.idAgent,
      yesLogout
    );
    this.setState({ modalDeleteCompte: false, idAgent: null });
  }
  CheckModalDeleteOpen(event, agentId) {
    let agent = Array.from(this.state.agents).find(
      (element) => element.id === agentId
    );
    let i = 0;
    this.state.agents.map(function(element) {
      if (element.typeCompte === "ADMIN_CRECHE" && agent.agentActif === true) {
        i = i + 1;
      }
    });
    if (agent.typeCompte === "ADMIN_CRECHE") {
      if (i > 1 && this.state.tokenDecoded.AGENT_ID === agentId) {
        this.setState({ ModaleDeletCompteMoreAdmin: true, idAgent: agentId });
      } else if (i > 1) {
        this.setState({ modalDeleteCompte: true, idAgent: agentId });
      } else if (i === 1) {
        this.setState({ modalErreurDeleteCompte: true, idAgent: agentId });
      }
    } else {
      let agent = Array.from(this.state.agents).find(
        (element) => element.id === agentId
      );
      this.setState({ modalDeleteCompte: true, idAgent: agentId });
    }
  }
  render() {
    const { t } = this.props;
    return (
      <div
        className="tab-pane fade show"
        id="staff-pane"
        role="tabpanel"
        aria-labelledby="staff-tab"
      >
        {this.props.isLoading ? (
          <div className="content p-0">
            <DotLoader
              size={100}
              color={"#ff7d26"}
              css={override}
              loading={this.props.isLoading}
            />
          </div>
        ) : (
          <div className="content p-0">
            <section className="content-section">
              <h2>{t('creche.staff_count', { count: this.state.numTotalAgent })}</h2>
              <div className="d-flex align-items-center justify-content-center">
                <button
                  onClick={this.openModalAjout}
                  className="btn-staff btn-gradient shadow-none"
                  data-toggle="modal"
                  data-target="#modalAddStaff"
                >
                  {" "}
                  <AddWhite /> <span>{t('staff.add')}</span>
                </button>
              </div>
              <div className="row">
                {this.state.agents.map((element, index) => {
                  let checked = element.agentActif === false;
                  return (
                    <div key={index} className="col-md-6 pl-0">
                      <div className="bloc-staff mt-4 box-shadow">
                        <div
                          onClick={(e) => {
                            if (
                              e.target.name !== "slider" ||
                              e.target.name !== "slider"
                            ) {
                              this.openModalModif(element);
                            }
                          }}
                        >
                          <h3>
                            {formatName(element.prenom, element.nom)}
                            <small>
                              {" "}
                              {switchTypeCompte(element.typeCompte)} (
                              {switchEtatCompte(element.etatCompte)})
                            </small>
                          </h3>
                          <p className="bg-email">{t('creche.email_label')} {element.email}</p>
                          <p className="bg-tel">
                            {t('creche.phone_label')} {element.numeroTel}
                          </p>
                          <p className="bg-fonction">
                            {t('creche.function_label')}{" "}
                            {switchFonction(element.fonction, element.sexe)}
                          </p>
                          <div className="agent-sections-badges" style={{ marginTop: "6px" }}>
                            {element.accesToutesLesSections ? (
                              <span className="badge" style={{
                                backgroundColor: "#4CAF50",
                                color: "#fff",
                                padding: "3px 8px",
                                borderRadius: "12px",
                                fontSize: "11px",
                                marginRight: "4px",
                              }}>{t('creche.all_sections')}</span>
                            ) : element.sections && element.sections.length > 0 ? (
                              element.sections.map((s, idx) => (
                                <span key={idx} className="badge" style={{
                                  backgroundColor: s.couleur || "#999",
                                  color: "#fff",
                                  padding: "3px 8px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  marginRight: "4px",
                                  marginBottom: "2px",
                                  display: "inline-block",
                                }}>{s.nom}</span>
                              ))
                            ) : (
                              <span style={{ fontSize: "11px", color: "#999", fontStyle: "italic" }}>{t('creche.no_section_assigned')}</span>
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-center mt-2">
                          <span>{t('creche.enabled')}</span>
                          <label
                            name="slider"
                            className="switch switch-green mx-2 mb-0"
                          >
                            <input
                              type="checkbox"
                              onChange={(e) =>
                                this.CheckModalOpen(
                                  e,
                                  element.id,
                                  element.agentActif
                                )
                              }
                              name="slider"
                              checked={checked}
                            />
                            <span name="slider" className="slider round"></span>
                          </label>
                          <span>{t('creche.disabled')}</span>
                        </div>
                        <a
                          className="delete-account"
                          onClick={(e) =>
                            this.CheckModalDeleteOpen(
                              e,
                              element.id,
                              element.agentActif
                            )
                          }
                        ></a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
            {this.state.isOpenAjout ? (
              <ModalAjoutStaff
                onClose={this.closeModalAjout}
                submitAjoutStaff={this.submitAjoutStaff}
              />
            ) : (
              ""
            )}
            {this.state.isOpenModif ? (
              <ModalModifStaff
                onClose={this.closeModalModif}
                submitModifStaff={this.submitModifStaff}
                agent={this.state.agent}
                listAgents={this.state.agents}
                allSections={this.props.allSections}
                updateAgentSections={this.props.updateAgentSections}
              />
            ) : (
              ""
            )}
            {this.state.modalOffCompte ? (
              <ModalConfiramtionOffCompte
                handleCouplageCompte={this.handleCouplageCompte}
                onCloseModalOffcompte={this.closeModalOffCompte}
                agentId={this.state.agentId}
              />
            ) : (
              ""
            )}
            {this.state.modalErreurCompte ? (
              <ModalErreurCompte
                closeModaErreurCompte={this.closeModaErreurCompte}
                handleCouplageCompte={this.handleCouplageCompte}
                agentId={this.state.agentId}
              />
            ) : (
              ""
            )}

            {this.state.modalDeleteCompte ? (
              <ModalConfiramtionDeleteCompte
                closeModalDeleteCompte={this.closeModalDeleteCompte}
                handleDeleteCompte={this.handleDeleteCompte}
                agentId={this.state.agentId}
              />
            ) : (
              ""
            )}
            {this.state.ModaleDeletCompteMoreAdmin ? (
              <ModalConfiramtionDeleteCompteMoreAdmin
                closeModaErreurDeleteCompteMoreAdmin={
                  this.closeModaErreurDeleteCompteMoreAdmin
                }
                handleDeleteCompte={this.handleDeleteCompte}
                agentId={this.state.agentId}
              />
            ) : (
              ""
            )}
            {this.state.modalErreurDeleteCompte ? (
              <ModalErreurDeleteCompte
                closeModaErreurDeleteCompte={this.closeModaErreurDeleteCompte}
                handleDeleteCompte={this.handleDeleteCompte}
                agentId={this.state.agentId}
              />
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  dataStaff: state.gestionCreche.staffPlan.data,
  isLoading: state.gestionCreche.staffPlan.loading,
  allSections: state.gestionCreche.sections.data || [],
});

const mapDispatchToProps = {
  getStaffCreche,
  postNewStaff,
  updateCouplageCompte,
  deleteAgent,
  updateStaff,
  updateAgentSections,
  getSections,
  getAccount,
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StaffCreche));
